import Skeleton, { SkeletonTheme, SkeletonProps } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styled from "styled-components";

export type BaseLoaderProps = {
  className?: string;
  id?: string;
  testId?: string;
};

export enum LoaderTestIds {
  SquareLoader = "square-loader",
  LoadingSkeleton = "skeleton-loader",
}

export type LoadingSkeletonProps = BaseLoaderProps & SkeletonProps;

export const LoadingSkeleton = ({
  testId = LoaderTestIds.LoadingSkeleton,
  className,
  id,
  ...rest
}: LoadingSkeletonProps) => {
  return (
    <StyledLoadingSkeleton className={className} data-testid={testId} id={id}>
      <SkeletonTheme
        baseColor="var(--color-primary-200)"
        highlightColor="var(--color-neutral-000-full)"
        duration={2}
      >
        <Skeleton height={10} {...rest} />
      </SkeletonTheme>
    </StyledLoadingSkeleton>
  );
};

const StyledLoadingSkeleton = styled.div<LoadingSkeletonProps>`
  width: 100%;
`;
